import React from 'react';

import {
  EdgesContext,
  EdgesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/EdgesContext';
import {FlowchartEditorModeContext} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/FlowchartEditorModeContext';
import {
  FlowchartFeatures,
  FlowchartFeaturesContext,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/FlowchartFeaturesContext';
import {
  HandlesContext,
  HandlesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/HandlesContext';
import {
  NodesContext,
  NodesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/NodesContext';
import {FlowchartEditorMode} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorModeConstants';

export interface CanvasContextProvidersProps {
  editorMode: FlowchartEditorMode;
  flowchartFeatures: FlowchartFeatures;
  handlesContext: HandlesContextValue;
  nodesContext: NodesContextValue;
  edgesContext: EdgesContextValue;
  children: React.ReactNode;
}

/**
 * Wraps the canvas in context providers needed for rendering the flowchart.
 */
export function CanvasContextProviders({
  editorMode,
  flowchartFeatures,
  handlesContext,
  nodesContext,
  edgesContext,
  children,
}: CanvasContextProvidersProps): JSX.Element {
  return (
    <FlowchartEditorModeContext.Provider value={editorMode}>
      <FlowchartFeaturesContext.Provider value={flowchartFeatures}>
        <HandlesContext.Provider value={handlesContext}>
          <NodesContext.Provider value={nodesContext}>
            <EdgesContext.Provider value={edgesContext}>{children}</EdgesContext.Provider>
          </NodesContext.Provider>
        </HandlesContext.Provider>
      </FlowchartFeaturesContext.Provider>
    </FlowchartEditorModeContext.Provider>
  );
}
